import React from "react";
import clxs from "./luma-filter.module.css";
import LUMA_LOGO from "../../../assets/icons/luma-logo.svg";
import useClx from "../../../hooks/use-clx";

interface LumaFilterProps {
    isFilterSelected?: boolean;
    onClick?: () => void;
}
function LumaFilter (props: LumaFilterProps) {
    const {onClick, isFilterSelected} = props;
    const ccx = useClx(
      clxs.lumaFilterButton,
      isFilterSelected && clxs.selectedLumaFilter,
    );

    return (
      <button 
        className={ccx} 
        onClick={onClick}
      >
        <img 
          src={LUMA_LOGO} 
          alt="icon" 
          className={clxs.tagIcon} 
        />
      </button>
    );
}

export default LumaFilter;